module.exports = __webpack_public_path__ + "img/DE00925.d845a0a6.png";